import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/screenshots/mazii_logo.png'


const _hoisted_1 = {
  class: "responsive-navbar offcanvas offcanvas-end border-0",
  "data-bs-backdrop": "static",
  tabindex: "-1",
  id: "navbarOffcanvas"
}
const _hoisted_2 = { class: "offcanvas-header" }
const _hoisted_3 = { class: "offcanvas-body" }
const _hoisted_4 = { class: "responsive-menu mobile-menu" }
const _hoisted_5 = { class: "responsive-menu-items" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "logo d-inline-block"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createElementVNode("img", {
            class: "logo-light",
            src: _imports_0,
            alt: "Image"
          }, null, -1),
          _createElementVNode("img", {
            class: "logo-dark",
            src: _imports_0,
            alt: "Image"
          }, null, -1)
        ])),
        _: 1
      }),
      _cache[2] || (_cache[2] = _createElementVNode("button", {
        type: "button",
        class: "close-btn bg-transparent lh-1 p-0",
        "data-bs-dismiss": "offcanvas",
        "aria-label": "Close"
      }, [
        _createElementVNode("i", { class: "ri-close-line" })
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        _cache[6] || (_cache[6] = _createStaticVNode("<li class=\"responsive-menu-list nav-item\" data-v-15e12f8c><a href=\"#hero-area\" class=\"nav-link\" data-v-15e12f8c>Home</a></li><li class=\"nav-item\" data-v-15e12f8c><a class=\"nav-link\" href=\"#about-area\" data-v-15e12f8c>Why Mazii</a></li><li class=\"nav-item\" data-v-15e12f8c><a class=\"nav-link\" href=\"#testimonials-area\" data-v-15e12f8c>What Couples Say</a></li><li class=\"nav-item\" data-v-15e12f8c><a class=\"nav-link\" href=\"#hw-area\" data-v-15e12f8c>More special features</a></li>", 4)),
        _createElementVNode("li", {
          class: _normalizeClass([
            'responsive-menu-list mobile-menu-child',
            { active: _ctx.isActivePages },
          ])
        }, [
          _createElementVNode("a", {
            href: "javascript:void(0)",
            class: "dropdown-toggle",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleActivePages && _ctx.toggleActivePages(...args)))
          }, " Pages "),
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createVNode(_component_router_link, { to: "/faq" }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("FAQ")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_router_link, { to: "/terms-conditions" }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode(" Terms & Conditions ")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_8, [
              _createVNode(_component_router_link, { to: "/privacy-policy" }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode(" Privacy Policy ")
                ])),
                _: 1
              })
            ])
          ])
        ], 2)
      ])
    ])
  ]))
}